'use client';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';

import { TradingSidebarSkeleton } from './TradingSidebarSkeleton';

export const SportDetailSkeleton = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <>
      {/* Main Content Area Skeleton */}
      <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
        {/* Header Skeleton */}
        <Box sx={{ mb: 4 }}>
          <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="60%" height={48} />
        </Box>

        {/* Score Card Skeleton */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 4,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              maxWidth: 600,
              mt: 4,
              px: { xs: 2, md: 4 },
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
              <Skeleton variant="rounded" width={64} height={64} sx={{ mb: 1.5 }} />
              <Skeleton variant="text" width={80} height={24} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 3 }}>
              <Skeleton variant="text" width={60} height={32} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
              <Skeleton variant="rounded" width={64} height={64} sx={{ mb: 1.5 }} />
              <Skeleton variant="text" width={80} height={24} />
            </Box>
          </Box>
        </Box>

        {/* Price Chart Skeleton */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap: 3 }}>
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2 }} />
        </Box>

        {/* Market Cards Skeleton */}
        <Box sx={{ mt: 2 }}>
          <Skeleton variant="text" width={120} height={32} sx={{ mb: 2 }} />
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              width="100%"
              height={120}
              sx={{ mb: 2, borderRadius: 3 }}
            />
          ))}
        </Box>
      </Box>

      {/* Right Sidebar Skeleton - Desktop Only */}
      {isDesktop && (
        <Box
          sx={{
            width: { lg: 320, xl: 360 },
            flexShrink: 0,
          }}
        >
          <TradingSidebarSkeleton />
        </Box>
      )}
    </>
  );
};
